import React, { useMemo, useState } from 'react'
import { ChampDansFormulaire } from './types/typePourChampDansFormulaireModel'
import { Input, Select, SelectProps, SxProps, Theme } from '@mui/material'
import { useForm, useFormContext } from 'react-hook-form'
import { fontFamilyMonserrat } from '../../theme'
import ErrorComponent from './ErrorComponent'
import { CUSTOM_TEXT_FIELD_STYLE } from './CustomTextField'
import { verificationErreursFormulaire } from '../../utils/utils'

type FormSelectFieldProps = ChampDansFormulaire & SelectProps &  SxProps<Theme>

const FormSelectField: React.FC<FormSelectFieldProps> = (
	{
		id,
		label,
		register,
		defaultValue = '',
		children,
		sx,
		disabled
	}
) => {
	const { formState: { errors } } = useForm()
	const { setValue, watch } = useFormContext()

	const erreurRemontee = useMemo(() => verificationErreursFormulaire(errors, register), [Object.keys(errors).length])

	return (
		<>
			{
				label && (
					<span
						style={{
							width: '100%',
							paddingRight: 15,
							paddingTop: 7,
							fontSize: 16,
							marginBottom: 5,
							marginLeft: 0,
							boxSizing: 'border-box',
							textAlign: 'left',
							fontFamily: fontFamilyMonserrat,
							fontWeight: 600
						}}
					>
						{label}
					</span>
				)
			}

			<Select
				name={register.name}
				value={watch(register.name)}
				onChange={(value) => setValue(register.name, value.target.value)}
				id={id}
				disabled={disabled}
				input={
					<Input
						color="primary"
						sx={CUSTOM_TEXT_FIELD_STYLE(erreurRemontee)}
						id={`select-text-field-${register.name}`}
						disableUnderline
						onBlur={() => {
						}}
					/>
				}
			>
				{children}
			</Select>

			{
				erreurRemontee.length > 0 && (
					<ErrorComponent>
						{erreurRemontee.length > 0}
					</ErrorComponent>
				)
			}
		</>
	)
}

export default FormSelectField
